import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setPageMeta } from "@/lib/pageMeta";

export default function NotFoundPage() {
  const navigate = useNavigate();

  useEffect(() => {
    setPageMeta({
      title: "Page Not Found — Utsah",
      description: "The page you are looking for could not be found.",
    });
    // Add a noindex meta so unknown URLs served by the SPA are not indexed by Google.
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    const previous = robots.getAttribute("content") || "";
    robots.setAttribute("content", "noindex, nofollow");
    return () => {
      // Restore/remove noindex when navigating away so it doesn't leak to other pages.
      if (previous) robots.setAttribute("content", previous);
      else robots.remove();
    };
  }, []);

  return (
    <div className="utsah-app" data-testid="not-found-page" style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "80px 24px", background: "var(--u-cream)" }}>
      <div style={{ textAlign: "center", maxWidth: 560 }}>
        <div className="eyebrow" style={{ display: "inline-flex", marginBottom: 16 }}>404</div>
        <h1 className="section-headline" style={{ marginBottom: 20 }}>
          This page could <em>not be found.</em>
        </h1>
        <p className="section-sub" style={{ marginBottom: 32 }}>
          The link you followed may be broken, or the page may have been moved.
        </p>
        <button className="hero-cta" onClick={() => navigate("/")} data-testid="not-found-home-btn">
          Return to Homepage
          <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden><path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button>
      </div>
    </div>
  );
}
